// extracted by mini-css-extract-plugin
export default {"consent":"screen_consent__54zLd","consent__text":"screen_consent__text__BzX1v","consent__form":"screen_consent__form__PzkhN"};